export default __webpack_public_path__ + "static/media/do.9d34fedb.mp3";